import { TFunction } from 'i18next';
import { FormLabelProps } from '@material-ui/core';
import { useState, ChangeEvent } from 'react';

const usePhoneInput = (t: TFunction, withRequiredValidation?: boolean) => {
  const [phone, setPhone] = useState<string>('+49');

  const onPhoneChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const target = e.target as HTMLInputElement;
    setPhone(target.value.trim().replace('\u202c', ''));
  };

  let rules: any = {
    pattern: {
      value: /^[+]*[0-9]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\\./0-9]*$/,
      message: t('validation.phone.format'),
    },
  };

  let labelProps: FormLabelProps = { htmlFor: 'phone' };

  if (withRequiredValidation) {
    rules = {
      ...rules,
      required: { value: true, message: t('validation.phone.required') },
    };
    labelProps = {
      ...labelProps,
      required: true,
    };
  }

  return {
    rules,
    labelProps,
    phone,
    onPhoneChange,
  };
};

export default usePhoneInput;
